
  var _styles = {
  "free-card-modal__outer-container": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "10rem",
    "position": "relative",
    "zIndex": 2
  },
  "free-card-modal__inner-container": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "10rem",
    "position": "relative",
    "zIndex": 2
  },
  "free-card-modal__vap-wrapper": {
    "position": "absolute",
    "width": "10rem",
    "top": 0,
    "left": 0,
    "zIndex": 0
  },
  "free-card-modal__content-wrapper": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "relative",
    "zIndex": 2
  },
  "unused-free-card-modal__wrapper": {
    "marginTop": "-0.4rem",
    "width": "7.44rem",
    "height": "9.98667rem",
    "overflow": "visible",
    "position": "relative",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "flex-start"
  },
  "unused-free-card-modal__header": {
    "position": "absolute",
    "zIndex": 1,
    "width": "2.73333rem",
    "height": "2.56rem"
  },
  "unused-free-card-modal__title-wrapper": {
    "marginTop": "3.49333rem",
    "width": "100%",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "unused-free-card-modal__title-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.56rem",
    "textAlign": "center"
  },
  "unused-free-card-modal__amount-wrapper": {
    "marginTop": "-0.2rem",
    "width": "100%",
    "flexDirection": "row",
    "alignItems": "baseline",
    "justifyContent": "center"
  },
  "unused-free-card-modal__amount-prefix": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.8rem"
  },
  "unused-free-card-modal__amount-content": {
    "color": "rgb(255,255,255)",
    "fontFamily": "MT New Digital Display",
    "fontWeight": "700",
    "fontSize": "1.6rem"
  },
  "unused-free-card-modal__use-button": {
    "position": "absolute",
    "bottom": "1.01333rem",
    "width": "5.33333rem",
    "height": "1.17333rem",
    "borderRadius": "0.6rem",
    "background": "#fff2a1",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "unused-free-card-modal__use-button-text": {
    "fontWeight": "600",
    "color": "rgb(17,17,17)",
    "fontSize": "0.42667rem",
    "textAlign": "center"
  },
  "unused-free-card-modal__expire-desc-wrapper": {
    "position": "absolute",
    "zIndex": 1,
    "width": "100%",
    "bottom": "0.4rem",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "unused-free-card-modal__expire-desc-text": {
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "center"
  },
  "used-free-card-modal__wrapper": {
    "marginTop": "2rem",
    "position": "relative",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "width": "8rem",
    "height": "7.2rem",
    "borderRadius": "0.64rem"
  },
  "used-free-card-modal__title": {
    "marginTop": "0.4rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.56rem",
    "textAlign": "center"
  },
  "used-free-card-modal__amount-wrapper": {
    "marginTop": "0.4rem",
    "width": "100%",
    "flexDirection": "row",
    "alignItems": "baseline",
    "justifyContent": "center"
  },
  "used-free-card-modal__amount-prefix": {
    "color": "rgb(255,85,0)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.8rem"
  },
  "used-free-card-modal__bind-name-text": {
    "maxWidth": "6.66667rem",
    "marginTop": "-0.13333rem",
    "fontWeight": "500",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem"
  },
  "used-free-card-modal__amount-content": {
    "color": "rgb(255,85,0)",
    "fontFamily": "MT New Digital Display",
    "fontWeight": "700",
    "fontSize": "1.6rem"
  },
  "used-free-card-modal__use-button": {
    "position": "absolute",
    "bottom": "1.09333rem",
    "width": "5.33333rem",
    "height": "1.28rem",
    "borderRadius": "0.8rem",
    "backgroundColor": "rgb(255,224,24)",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "used-free-card-modal__use-button-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.48rem",
    "textAlign": "center"
  },
  "used-free-card-modal__expire-desc-text": {
    "position": "absolute",
    "bottom": "0.34667rem",
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem"
  },
  "used-free-card-modal__tag-wrapper": {
    "width": "3.2rem",
    "height": "2.57333rem",
    "position": "absolute",
    "top": "0.2rem",
    "right": "-0.2rem"
  },
  "used-free-card-modal__tag-img": {
    "width": "3.2rem",
    "height": "2.57333rem"
  },
  "modal-close-button": {
    "marginTop": "0.64rem",
    "height": "0.64rem",
    "width": "100%",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "position": "relative",
    "zIndex": 2
  },
  "modal-close-button-img": {
    "width": "0.64rem",
    "height": "0.64rem"
  }
};



  module.exports = _styles;
  